// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Aj-z","tupacHeader":"Bj-z","tupacHeader2":"Cj-z","tupacMenu":"Dj-z","tupacMenu2":"Ej-z","tupacMain":"Fj-z","tupacMain2":"Gj-z"};